'use client';

import { MappingIcon, mappingIconTag } from '@ni/nimble-components/dist/esm/mapping/icon';
import { wrap } from '../../utilities/react-wrapper';

export { mappingIconTag };
export { type MappingIcon };
export const NimbleMappingIcon = wrap(MappingIcon);
